import { QuestionOptions } from '@refineintel/types';
import { INVESTIGATION_STATUS } from './GeneralTypes';

export type Question = {
	index: number;
	qid: string;
	type: questionType;
	questionText: string;
	// possibleAnswers: PossibleAnswer[];
	// possibleAnswers: Object;
	possibleAnswers: any;
	// possibleAnswers: Map<string, PossibleAnswer>;
	// possibleAnswers: Map<string, Map<string, PossibleAnswer>>;
	answer: Answer | undefined;
	timeLineStatus: string;
	priorProgress: number;
	isOptional?: boolean;
	additionalOptions?: QuestionOptions;
};

export enum questionType {
	MULTIPLECHOICE = 'multipleChoice',
	OUCF_CHECK_QUESTION = 'oucfCheckQuestion',
	OPENANSWER = 'openAnswer',
	DYNAMIC_OPTIONS_QUESTION = 'dynamicOptions',
	CTR_QUESTION = 'ctrQuestion',
}

export type PossibleAnswer = {
	// index: number;
	text: string;
	answerId: string;
	icon: string;
	isOpen?: boolean;
	nextQuestion?: string;
};

export type Answer = {
	answeredBy: ANSWER_SOURCE;
	answerId: string;
	answerText: string;
	lang: string;
	openAnswer: string | undefined;
	additionalOptions?: AdditionalAnswerOptions;
};

export enum ANSWER_SOURCE {
	BRANCH = 'branch',
	CLIENT = 'client',
}

export type Alert = {
	alertId: string;
	dateCreated: string;
	summary: string;
};

export type Account = {
	customerName: string;
	accountNumber: string;
	branch: string;
	phone1: string;
	phone2: string;
	email: string;
};

export type Transaction = {
	date: string;
	value: string;
	type: string;
	payee: string;
	payeeAccountNumber: string;
};

export type QuestionAndAnswer = {
	question: Question;
	answer: Answer;
};

export type InvestigationDetails = {
	alert: Alert;
	bankerOutreachText: string;
	account: Account;
	investigationType: 'oucf' | 'aml' | 'edd';
	// transactions: Transaction[],
	transactions: Array<any>;
	questionsAndAnswersHistory: Map<string, Map<string, Question | Answer>> | {};
	questionsHistory: string[]; //an array representing the order of the asked questions
	// If first time this will be the first question, otherwise will be the next question
	nextQuestion: Question;
	status: string;
	channel: string; // base64 encoded Email/Phone
	lang: string;
	checkImages?: { id: string; signedUrl: string }[];
	//Cutoff screen data
	checkImage?: {
		id: string;
		signedUrl: string;
	};

	checkNumber?: string;
	context?: string;

	note?: string;

	partyName?: string;
};

export enum TIMELINE_STATUS {
	INTRODUCTION = 0,
	OVERVIEW = 1,
	DETAILS = 2,
	MOODASSESSMENT = 3,
	SUBMISSION = 4,
	COMPLETED = 5,
}

export type QuestionResponse = {
	nextQuestion: Question;
	status: INVESTIGATION_STATUS;
};

export type AdditionalAnswerOptions = {
	fileUploadChecked?: boolean;
};
